import Bootstrap from '$js/bootstrap';
import BaseModule from '$js/base/BaseModule';
import { initBouncerValidation } from '$src/js/modules/form-validation/init-bouncer';

new Bootstrap();
initBouncerValidation();

if (document.querySelector('[data-cookie-consent]')) {
  import('./modules/cookie-consent/CookieConsentClass')
    .then(({ CookieConsentClass }) => {
      new CookieConsentClass();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('[data-cart]') && document.querySelector('[data-cart-amount]')) {
  import('./modules/cart-amount/CartAmountClass')
    .then(({ CartAmountClass }) => {
      new CartAmountClass();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('[data-cart]') && document.querySelector('[data-cart-remove]')) {
  import('./modules/cart-remove/CartRemoveClass')
    .then(({ CartRemoveClass }) => {
      new CartRemoveClass();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (
  document.querySelector('[data-address-shipping]') &&
  document.querySelector('[data-shipping-address-same-as-billing]')
) {
  import('./modules/checkbout-address/CheckoutAddressClass')
    .then(({ CheckoutAddressClass }) => {
      new CheckoutAddressClass();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (document.querySelector('[data-product-image="main"]')) {
  import('./modules/product-image/ProductImageClass')
    .then(({ ProductImageClass }) => {
      new ProductImageClass();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}

if (
  document.querySelector('[data-add-to-cart]') &&
  document.querySelector('[data-product-adjust-price]') &&
  document.querySelector('[data-product-stock]') &&
  document.querySelector('input[name="purchasableId"]')
) {
  import('./modules/product-variant/ProductVariantClass')
    .then(({ ProductVariantClass }) => {
      new ProductVariantClass();
    })
    .catch((error: unknown) => BaseModule.getInstance().error.throwError(error));
}
